export const MACHINES_PER_REQUEST = 15;

// Timeout for SignalR response when resetting priority (30 seconds)
// TODO: may be changed later
export const RESET_PRIORITY_TIMEOUT_MS = 30000;

// TODO: may be changed later or deleted entirely
// Delay before refetching after reset priority finishes.
// The search index may not be updated immediately after the backend signals completion,
// so we wait briefly to avoid fetching stale data.
export const RESET_REFETCH_DELAY_MS = 1500;

// Modal arrow pointer constants
export const MODAL_ARROW = {
  HEIGHT: 10, // Vertical height of the triangle arrow
  HALF_WIDTH: 15, // Half of the visible width (for horizontal position clamping)
  // SVG path geometry constants (based on popupSvgTriangles pattern)
  TRIANGLE_SIZE_CONFIG: 6.48528, // Diagonal length for smooth curve at triangle tip
  TRIANGLE_CONTENT_OFFSET: 10, // Where triangle body meets rectangle edge
  ARROW_COLOR: 'Background/Light/Field on modal'
} as const;
